export const ProductionMachineChangeover = (json: IProductionMachineChangeover): IProductionMachineChangeoverModel => {
	const { short_name, ...rest } = json

	return {
		...rest,
		shortName: short_name,
	}
}

export const ProductionActivityRequest = (json: IProductionActivityRequest): IProductionActivityRequestModel => {
	const { position_id, start_date, end_date, description, changeover_id, related_task_id, ...rest } = json

	return {
		...rest,
		positionId: position_id,
		start_date,
		end_date,
		description,
		changeoverId: changeover_id,
		relatedTaskId: related_task_id,
	}
}

export const ProductionActivityRequestToJson = (json: IProductionActivityRequestModel): IProductionActivityRequest => {
	const { positionId, start_date, end_date, description, changeoverId, relatedTaskId, ...rest } = json

	return {
		...rest,
		position_id: positionId,
		start_date,
		end_date,
		description,
		changeover_id: changeoverId,
		related_task_id: relatedTaskId,
	}
}
